// extracted by mini-css-extract-plugin
export default {"displayImage":"displayImage_displayImage__kBed+"};